import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#000",
      "stroke-width": ".2"
    }, [
      _createElementVNode("path", { d: "M5.9 14.367c0 .22.18.4.4.4h.855a3.513 3.513 0 0 0 4.505 1.926.4.4 0 1 0-.288-.746 2.71 2.71 0 0 1-3.327-1.18H10.6a.4.4 0 0 0 0-.8H7.743a2.7 2.7 0 0 1-.046-.8H10.9a.4.4 0 0 0 0-.8H7.897a2.71 2.71 0 0 1 3.475-1.48.4.4 0 1 0 .288-.747 3.51 3.51 0 0 0-4.613 2.227H6.3a.4.4 0 0 0 0 .8h.596q-.028.401.034.8H6.3a.4.4 0 0 0-.4.4Z" }),
      _createElementVNode("path", { d: "M1.401 24H18.1c.22 0 .401-.204.401-.425V5.472c0-.11-.046-.222-.118-.272l-4.048-4.053v-.015A.4.4 0 0 0 14.05 1H1.4c-.219 0-.4.204-.4.425v22.15c0 .221.18.425.401.425ZM14.45 2.39l2.683 2.66H14.45zM1.8 1.8h11.85v3.672c0 .222.18.378.4.378h3.65V23.2H1.8z" })
    ], -1)
  ])))
}
export default { render: render }